import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import checkIsMobile from 'shared/utils/checkMobileDevice';
import { Icon } from 'shared/components';

import theme from './RemoteMediaDisabled.scss';

const propTypes = {
  switchedLayout: PropTypes.bool.isRequired,
  iconName: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  message: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
  }).isRequired,
};

const defaultProps = {};

const RemoteMediaDisabled = ({ switchedLayout, iconName, message, language }) => (
  <div
    className={ classnames(theme.root, {
      [theme.notSwitchedLayout]: !switchedLayout,
      [theme.switchedLayout]: switchedLayout,
      [theme.switchedHeLanguage]: language === 'he',
    }) }
  >
    <div className={ theme.media }>
      <Icon className={ theme.icon } name={ iconName } />
      <span className={ theme.message }>
        <FormattedMessage { ...message } />
      </span>
    </div>
  </div>
);

RemoteMediaDisabled.propTypes = propTypes;
RemoteMediaDisabled.defaultProps = defaultProps;

export default RemoteMediaDisabled;
